import { makeToast, removeToast } from "./toast.store";

/**
 * @deprecated Use `useSnackbar()` from `@fullscript/aviary-web` instead.
 */
const useToast = () => {
  return { makeToast, removeToast };
};

export { useToast };
